/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function init() {
  if (!hasSeenAcknowledgement()) {
    showAcknowledgement()
  }
}

function hasSeenAcknowledgement() {
  const localValue = window.localStorage.getItem('acknowledgement')
  return localValue && isWithin14Days(new Date(localValue), new Date())
}

function showAcknowledgement() {
  $('[data-acknowledgement]').show().delay(7500).fadeOut()

  $('[data-acknowledgement-button]').on('click', () => {
    $('[data-acknowledgement]').dequeue()
  })

  window.localStorage.setItem('acknowledgement', new Date())
}
// update function to check if is within 14 days instead of same day
function isWithin14Days(date1, date2) {
  const diffTime = Math.abs(date2 - date1)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays <= 14
}
